<template>
      <div no-body class="lku-grade"> 
      <b-row>
        <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend><label>Filter</label></b-input-group-prepend>
              <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblGol"
          responsive
          striped hover
          :items="items"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc" 
          :key="tblData.page"
          @row-clicked="selectItem"
        >
        <template v-slot:cell(nomor)="data">
          {{ (tblData.page - 1) * tblData.limit + (data.index + 1)}}
        </template>
        </b-table>
      <b-row>
        <b-col cols="4">
          <div class="pt-2">
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
        </div>        
        </b-col>
        <b-col cols="3">            
            <b-row class="ml-2 mt-2">
              <span class="pt-1 pr-2">Limit per page</span>
              <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px !important;"/>
            </b-row>
        </b-col>
        <b-col cols="5">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
  </div>
</template>
<style lang="scss">
  .lku-grade {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import crud from "../../apis/crud";
import toastr from "mini-toastr";
toastr.init();

export default {
  data() {
    return {
      fields: [
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "golongan",
            label: "Name",
            sortable: true
          },
          {
            key: "golongankd",
            label: "Code",
            sortable: true
          },
      ],
      items:[],
      tblData: {
        tablename:'job-group',
        page: 1,
        limit:10000,
        total: 0,
        sortBy: 'golongan',
        sortDesc: false
      },
      filter:null
    };
  },
  created: async function() {
      this.data();
  },
  mounted() {
    // Set the initial number of items
    this.tblData.total = this.items.length;
  },
  methods: {
    // onFiltered(filteredItems) {
    //   this.tblData.total = filteredItems.length;
    //   this.tblData.page = 1;
    // },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      // this.items=await crud.list(this.tblData);
      // return this.items;      
      const list = await crud.list(this.tblData);      
      this.lkuLoading=false;
      this.items=list;
      this.tblData.limit= 20;
    },
    selectItem(item,index) {
        // const idxChg = this.items.findIndex((rec)=>{
        //                 return (rec.kodegroup.startsWith(item.kodegroup) && (rec.kodegroup !==item.kodegroup));
        //             })
        // if ((idxChg || -1) > -1) {
        //   console.log ('Account punya anak tidak boleh dipilih');
        //     toastr.warn('Account punya anak tidak boleh dipilih!');
        // } else {
        this.$emit("click", item);
        // }
    },  
    refresh() {
      this.$refs.tblGol.refresh();
    }
  }
};
</script>
